import type { CSSProperties } from 'react';
import { ResolvedTheme } from '../../theme/ThemeProvider';

export const chartColors = {
  delivered: '#22c55e',
  inTransit: '#f7941e',
  totalCreated: '#009ce0',
  office: '#009ce0',
  mode: '#f16a6a',
  otd: '#f7941e',
};

/** Paleta para el donut de Operation Type (orden de la leyenda). */
export const operationPalette = [
  '#8ecae6',
  '#009ce0',
  '#f7941e',
  '#ef5350',
  '#22c55e',
  '#a78bfa',
  '#14b8a6',
  '#f59e0b',
];

export const axisTheme = (theme: ResolvedTheme) =>
  theme === 'dark'
    ? { axis: '#9a9fa8', grid: '#2c2c2c' }
    : { axis: '#8a8f98', grid: '#eef0f3' };

/** Color de texto (label + items) del tooltip, para que contraste con su fondo. */
export const tooltipText = (theme: ResolvedTheme): CSSProperties => ({
  color: theme === 'dark' ? '#f5f5f5' : '#222222',
});

export const tooltipStyle = (theme: ResolvedTheme): CSSProperties =>
  theme === 'dark'
    ? {
        background: '#262626',
        border: '1px solid #3a3a3a',
        borderRadius: 10,
        color: '#f5f5f5',
        fontSize: 12,
      }
    : {
        background: '#ffffff',
        border: '1px solid #e4e7ec',
        borderRadius: 10,
        color: '#222',
        fontSize: 12,
      };
